import { filterPathname } from '../../components/pageMeta/SEOURLUtils';
import { H1_TAG_TITLE } from '../constants/stringConstants';
import { DISPLAY_LANGUAGE_LIST } from '../constants/utilConstants';

const pageNameConstants = {
  HOME: 'home',
  PREMIUM: 'premium',
  SHOW_LANDING: 'show_landing',
  SHOW_DETAIL: 'show_detail',
  SHOWS_LANGUAGE: 'shows_language',
  SHOWS_GENRE: 'shows_genre',
  SHOWS_LANGUAGE_GENRE: 'shows_language_genre',
  SHOWS_GENRE_LANGUAGE: 'shows_genre_language',
  SHOWS_TRENDING: 'shows_trending',
  SHOWS_CHANNEL: 'shows_channel',
  EPISODE_DETAIL: 'episode_detail',
  MOVIE_LANDING: 'movie_landing',
  MOVIE_DETAIL: 'movie_detail',
  MOVIE_LANGUAGE: 'movie_language',
  MOVIE_GENRE: 'movie_genre',
  MOVIE_YEAR: 'movie_year',
  NEWS_LANDING: 'news_landing',
  NEWS_DETAIL: 'news_detail',
  VIDEO_LANDING: 'video_landing',
  VIDEO_DETAIL: 'video_detail',
  ZEE5_ORIGINAL_LANDING: 'zee5originals_landing',
  ZEE5_ORIGINAL_DETAIL: 'zee5originals_detail',
  WEB_SERIES_LANGUAGE: 'web_series_language',
  WEB_SERIES_GENRE: 'web_series_genre',
  WEB_SERIES_LANGUAGE_GENRE: 'web_series_language_genre',
  WEB_SERIES_GENRE_LANGUAGE: 'web_series_genre_language',
  KIDS_LANDING: 'kids_landing',
  FREE_MOVIES_LANDING: 'free_movies_landing',
  CLUB_LANDING: 'club_landing',
  KIDS_SHOW_DETAIL: 'kids_show_detail',
  KIDS_EPISODE_DETAIL: 'kids_episode_detail',
  KIDS_MOVIE_DETAIL: 'kids_movie_detail',
  KIDS_VIDEO_DETAIL: 'kids_video_detail',
  KIDS_SEASON_VIEW_ALL: 'kids_season_view_all',
  UPCOMING_LANDING: 'upcoming_landing',
  STORIES_LANDING: 'stories_landing',
  MUSIC_LANDING: 'music_videos_landing',
  PLAY_LANDING: 'play_landing',
  MUSIC_DETAIL: 'music_videos_detail',
  VIEW_ALL: 'view_all',
  LIVE_TV: 'live_tv',
  LIVETV_PREMIUMCHANNELS: 'live_tv_premium_channels',
  LIVETV_FREECHANNELS: 'live_tv_free_channels',
  LIVETV_LANGUAGE: 'live_tv_language_page',
  LIVETV_GENRE: 'live_tv_genre_page',
  LIVETV_LANGUAGE_GENRE: 'live_tv_language_genre_page',
  TV_GUIDE: 'tv_guide',
  CHANNEL_DETAIL: 'channel_detail',
  SPORTS_DETAIL: 'sports_detail',
  MOVIE_VIEW_ALL: 'movies_view_all',
  VIDEOS_VIEW_ALL: 'videos_view_all',
  ZEE5_ORIGINALS_VIEW_ALL: 'zee_originals_view all',
  MUSICS_VIEW_ALL: 'music_view all',
  LIVETV: 'livetv_Channel',
  CHANNELS: 'channels',
  TV_SHOWS_VIEW_ALL: 'tv_shows_view_all',
  ABOUT_US: 'about_us',
  FAQS: 'help',
  CONTACT_US: 'contact_us',
  SETTINGS: 'settings',
  SEARCH: 'search',
  SEASON_VIEW_ALL: 'season_view_all',
  TERMS_OF_USE: 'terms_of_use',
  PAYMENT: 'payment_page',
  PRIVACY_POLICY: 'privacy_policy',
  MY_PROFILE: 'my_profile',
  MY_PROFILE_REMINDER: 'my_profile_reminders',
  MY_PROFILE_WATCHLIST: 'my_profile_watchlist',
  MY_PROFILE_CHANGE_PASSWORD: 'my_profile_change_password',
  MY_PROFILE_EDIT_PROFILE: 'user_profile_edit_profile',
  SIGN_IN: 'sign_in',
  REGISTER: 'register',
  ACCOUNT_INFO: 'account_info',
  FORGOT_PASSWORD: 'forgot_password',
  RESET_PASSWORD: 'reset_password',
  FORGOT_SET_PASSWORD_MOBILE: 'forgot_set_password_mobile',
  FORGOT_PASSWORD_VERIFY_MOBILE: 'forgot_password_verify_mobile',
  MY_PROFILE_PAYMENTS: 'my_profile_payments',
  MANAGE_DEVICES: 'manage_devices',
  MY_PROFILE_PLANS: 'my_profile_plans',
  MY_PROFILE_RENTALS: 'my_profile_rentals',
  PACK_SELECTION: 'pack_selection',
  PARENTAL_CONTROL: 'parental_control',
  // PAYMENT_SUCCESS: "payment_success", // Removed as per mixpanel sheet for new subscription PWA2-7279
  ORDER_SUMMARY_SCREEN: 'Order Summary Screen',
  PAYMENT_FAILURE: 'payment_failure',
  OTP_PAGE: 'otp_page',
  SEASONS: 'seasons',
  DEVICE_AUTHENTICATION: 'device_authentication',
  NFT: 'My Nft',
  SUBSCRIPTION: 'Subscription',
  LIVE_TV_NEWS_CHANNELS: 'live_tv_news_channels',
  ZEE5_APP_LANDING: 'zee5-appLanding',
  EDUAURAA_SUCCESS: 'eduauraa_success',
  PLEX_LANDING: 'zee_plex_landing',
  TV_CHANNEL: 'tv_channel_landing',
  TV_CHANNEL_DETAIL: 'tv_channel_detail',
  MORE_SECTION: 'more_section',
  COMBO_PACK: 'combo_pack',
  LEARNING: 'learning',
  STUDENT: 'student',
  CONSUMPTION: 'consumption',
  USREFERRAL: 'Refer Details Screen',
  EDUAURAA: 'eduauraa',
  ILT20: 'ILT20',
  ILT20_CONSUMPTION_PAGE: 'ILT20 ConsumptionPage',
  ILT20_SCHEDULE: 'ILT20 Schedule'
};

const routes = [
  {
    path: '/',
    pageName: pageNameConstants.HOME
  },
  {
    path: '/premium',
    pageName: pageNameConstants.PREMIUM
  },
  {
    path: '/movies',
    pageName: pageNameConstants.MOVIE_LANDING
  },
  {
    path: '/news',
    pageName: pageNameConstants.NEWS_LANDING
  },
  {
    path: '/music-videos',
    pageName: pageNameConstants.MUSIC_LANDING
  },
  {
    path: '/play5-games',
    pageName: pageNameConstants.PLAY_LANDING
  },
  {
    path: `/${process.env.NEXT_PUBLIC_TVSHOWS}`,
    pageName: pageNameConstants.SHOW_LANDING
  },
  {
    path: '/videos',
    pageName: pageNameConstants.VIDEO_LANDING
  },
  {
    path: '/free-movies',
    pageName: pageNameConstants.FREE_MOVIES_LANDING
  },
  {
    path: '/club-pack',
    pageName: pageNameConstants.PREMIUM
  },
  {
    path: '/aboutus',
    pageName: pageNameConstants.ABOUT_US
  },
  {
    path: '/termsofuse',
    pageName: pageNameConstants.TERMS_OF_USE
  },
  {
    path: '/privacypolicy',
    pageName: pageNameConstants.PRIVACY_POLICY
  },
  {
    path: `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}`,
    pageName: pageNameConstants.ZEE5_ORIGINAL_LANDING
  },
  {
    path: '/upcoming',
    pageName: pageNameConstants.UPCOMING_LANDING
  },
  {
    path: '/movies/all',
    pageName: pageNameConstants.MOVIE_VIEW_ALL
  },
  {
    path: `/${process.env.NEXT_PUBLIC_TVSHOWS}/all`,
    pageName: pageNameConstants.TV_SHOWS_VIEW_ALL
  },
  {
    path: `/${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}/all`,
    pageName: pageNameConstants.ZEE5_ORIGINALS_VIEW_ALL
  },
  {
    path: '/videos/all',
    pageName: pageNameConstants.VIDEOS_VIEW_ALL
  },
  {
    path: '/music-videos/all',
    pageName: pageNameConstants.MUSICS_VIEW_ALL
  },
  {
    path: '/channels',
    pageName: pageNameConstants.CHANNELS
  },
  {
    path: '/myprofile',
    pageName: pageNameConstants.MY_PROFILE
  },
  {
    path: '/myprofile/plans',
    pageName: pageNameConstants.MY_PROFILE_PLANS
  },
  {
    path: '/myprofile/rentals',
    pageName: pageNameConstants.MY_PROFILE_RENTALS
  },
  {
    path: '/collections',
    component: pageNameConstants.VIEW_ALL
  },
  {
    path: '/signin',
    pageName: pageNameConstants.SIGN_IN
  },
  {
    path: '/search',
    pageName: pageNameConstants.SEARCH
  },
  {
    path: '/settings',
    pageName: pageNameConstants.SETTINGS
  },
  {
    path: '/device',
    pageName: pageNameConstants.DEVICE_AUTHENTICATION
  },
  {
    path: '/movies/details',
    pageName: pageNameConstants.MOVIE_DETAIL
  },
  {
    path: '/myprofile/watchlist',
    pageName: pageNameConstants.MY_PROFILE_WATCHLIST
  },
  {
    path: '/myprofile/reminders',
    pageName: pageNameConstants.MY_PROFILE_REMINDER
  },
  {
    path: '/myprofile/payments',
    pageName: pageNameConstants.MY_PROFILE_PAYMENTS
  },
  {
    path: '/myprofile/managedevices',
    pageName: pageNameConstants.MANAGE_DEVICES
  },
  {
    path: '/channels/details',
    pageName: pageNameConstants.CHANNEL_DETAIL
  },
  {
    path: '/videos/details',
    pageName: pageNameConstants.VIDEO_DETAIL
  },
  {
    path: '/music-videos/details',
    pageName: pageNameConstants.MUSIC_DETAIL
  },
  {
    path: '/news/details',
    pageName: pageNameConstants.NEWS_DETAIL
  },
  {
    path: '/verify-mobile-number',
    pageName: pageNameConstants.OTP_PAGE
  },
  {
    path: '/forgotpassword',
    pageName: pageNameConstants.FORGOT_PASSWORD
  },
  {
    path: '/forgotsetpassword',
    pageName: pageNameConstants.FORGOT_SET_PASSWORD_MOBILE
  },
  {
    path: '/forgotverifymobile',
    pageName: pageNameConstants.FORGOT_PASSWORD_VERIFY_MOBILE
  },
  {
    path: '/register',
    pageName: pageNameConstants.REGISTER
  },
  {
    path: `${process.env.NEXT_PUBLIC_LIVETV}`,
    pageName: pageNameConstants.LIVE_TV
  },
  {
    path: `${process.env.NEXT_PUBLIC_TVGUIDE}`,
    pageName: pageNameConstants.TV_GUIDE
  },
  {
    path: '/help',
    pageName: pageNameConstants.FAQS
  },
  {
    path: '/paymentsuccess',
    pageName: pageNameConstants.ORDER_SUMMARY_SCREEN
  },
  {
    path: '/paymentfailure',
    pageName: pageNameConstants.PAYMENT_FAILURE
  },
  {
    path: '/paymentcancelled',
    pageName: pageNameConstants.PAYMENT_FAILURE
  },
  {
    path: '/myaccount/subscription',
    pageName: pageNameConstants.PACK_SELECTION
  },
  {
    path: '/offers/:contentId',
    pageName: pageNameConstants.COMBO_PACK
  },
  {
    path: '/myaccount/account-info',
    pageName: pageNameConstants.ACCOUNT_INFO
  },
  {
    path: '/myaccount/payment',
    pageName: pageNameConstants.PAYMENT
  },
  {
    path: '/parentalcontrol',
    pageName: pageNameConstants.PARENTAL_CONTROL
  },
  {
    path: '/kids',
    pageName: pageNameConstants.KIDS_LANDING
  },
  {
    path: '/kids/kids-shows',
    pageName: pageNameConstants.KIDS_SHOW_DETAIL
  },
  {
    path: '/kids/kids-movies',
    pageName: pageNameConstants.KIDS_MOVIE_DETAIL
  },
  {
    path: '/kids/kids-videos',
    pageName: pageNameConstants.KIDS_VIDEO_DETAIL
  },
  {
    path: '/zeekannada/news',
    pageName: pageNameConstants.STORIES_LANDING
  },
  {
    path: '/live-tv/news-channels',
    pageName: pageNameConstants.LIVE_TV_NEWS_CHANNELS
  },
  {
    path: '/zee5-app',
    pageName: pageNameConstants.ZEE5_APP_LANDING
  },
  {
    path: '/eduauraa-offer/success',
    pageName: pageNameConstants.EDUAURAA_SUCCESS
  },
  {
    path: '/zee-plex-movies-on-rent',
    pageName: pageNameConstants.PLEX_LANDING
  },
  {
    path: '/tv-shows/tv-channels',
    pageName: pageNameConstants.TV_CHANNEL
  },
  {
    path: '/tv-shows/:channelName/:channelId',
    pageName: pageNameConstants.TV_CHANNEL_DETAIL
  },
  {
    path: `/${process.env.NEXT_PUBLIC_EDUAURAA}`,
    pageName: pageNameConstants.EDUAURAA
  },
  {
    path: '/student',
    pageName: pageNameConstants.STUDENT
  },
  {
    path: '/USReferral',
    pageName: pageNameConstants.USREFERRAL
  }
];

export const getPageName = (pathName: string) => {
  const pathNameFiltered = filterPathname(pathName);
  let pageName =
    routes.filter(
      (item) => item && item.path && item.path.includes(pathNameFiltered)
    )[0] &&
    routes.filter((item) => item?.path?.includes(pathNameFiltered))[0].pageName;

  if (!pageName) {
    const items = pathNameFiltered.split('/');
    if (items[1] === `${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}`) {
      if (items[6] === 'episodes') {
        pageName = pageNameConstants.SEASONS;
      } else if (items[2] === 'lang') {
        if (items.length === 3) {
          pageName = pageNameConstants.WEB_SERIES_LANGUAGE_GENRE;
        } else {
          pageName = pageNameConstants.WEB_SERIES_LANGUAGE;
        }
      } else if (items[2] === 'genre') {
        if (items.length === 3) {
          pageName = pageNameConstants.WEB_SERIES_GENRE_LANGUAGE;
        } else {
          pageName = pageNameConstants.WEB_SERIES_GENRE;
        }
      } else if (items.length === 5) {
        pageName = pageNameConstants.SHOW_DETAIL;
      } else if (items.length === 6) {
        if (items[5] === 'latest' || items[5] === 'latest1') {
          pageName = pageNameConstants.ZEE5_ORIGINAL_DETAIL;
        } else {
          pageName = pageNameConstants.SEASON_VIEW_ALL;
        }
      } else if (items.length === 7) {
        pageName = pageNameConstants.ZEE5_ORIGINAL_DETAIL;
      } else if (items[1] === `${process.env.NEXT_PUBLIC_ZEE5ORIGINALS}`) {
        pageName = pageNameConstants.ZEE5_ORIGINAL_LANDING;
      }
    } else if (items[1] === `${process.env.NEXT_PUBLIC_TVSHOWS}`) {
      if (items[6] === 'episodes') {
        pageName = pageNameConstants.SEASONS;
      } else if (items[2] === 'lang') {
        if (items.length === 3) {
          pageName = pageNameConstants.SHOWS_LANGUAGE_GENRE;
        } else {
          pageName = pageNameConstants.SHOWS_LANGUAGE;
        }
      } else if (items[2] === 'genre') {
        if (items.length === 3) {
          pageName = pageNameConstants.SHOWS_GENRE_LANGUAGE;
        } else {
          pageName = pageNameConstants.SHOWS_GENRE;
        }
      } else if (items[2] === 'trending') {
        pageName = pageNameConstants.SHOWS_TRENDING;
      } else if (items.length === 4) {
        pageName = pageNameConstants.SHOWS_CHANNEL;
      } else if (items.length === 5) {
        pageName = pageNameConstants.SHOW_DETAIL;
      } else if (items.length === 6) {
        if (items[5] === 'latest' || items[5] === 'latest1') {
          pageName = pageNameConstants.EPISODE_DETAIL;
        } else {
          pageName = pageNameConstants.SEASON_VIEW_ALL;
        }
      } else if (items.length === 7) {
        pageName = pageNameConstants.EPISODE_DETAIL;
      } else if (items[1] === `${process.env.NEXT_PUBLIC_TVSHOWS}`) {
        pageName = pageNameConstants.SHOW_LANDING;
      }
    } else if (items[1] === 'movies') {
      switch (items[2]) {
        case 'details':
          pageName = pageNameConstants.MOVIE_DETAIL;
          break;
        case 'lang':
          pageName = pageNameConstants.MOVIE_LANGUAGE;
          break;
        case 'genre':
          pageName = pageNameConstants.MOVIE_GENRE;
          break;
        case 'year':
          pageName = pageNameConstants.MOVIE_YEAR;
          break;
        default:
          pageName = pageNameConstants.MUSIC_LANDING;
          break;
      }
    } else if (items[1] === 'news') {
      pageName = pageNameConstants.NEWS_DETAIL;
    } else if (items[1] === `${process.env.NEXT_PUBLIC_CHANNELS}`) {
      pageName = pageNameConstants.CHANNEL_DETAIL;
    } else if (items[1] === 'music-videos') {
      pageName = pageNameConstants.MUSIC_DETAIL;
    } else if (items[1] === 'videos') {
      pageName = pageNameConstants.VIDEO_DETAIL;
    } else if (items[1] === 'collections') {
      pageName = `${pageNameConstants.VIEW_ALL}_${items[2]}`;
    } else if (items[1] === 'resetpassword') {
      pageName = pageNameConstants.RESET_PASSWORD;
    } else if (items[1] === 'kids') {
      if (items[2] === 'kids-shows') {
        if (items.length === 5) {
          pageName = pageNameConstants.KIDS_SHOW_DETAIL;
        } else if (items.length === 6) {
          if (items[5] === 'latest' || items[5] === 'latest1') {
            pageName = pageNameConstants.KIDS_EPISODE_DETAIL;
          } else {
            pageName = pageNameConstants.KIDS_SEASON_VIEW_ALL;
          }
        } else if (items.length === 7) {
          pageName = pageNameConstants.KIDS_EPISODE_DETAIL;
        } else if (items[6] === 'episodes') {
          pageName = pageNameConstants.SEASONS;
        }
      } else if (items[2] === 'kids-movies') {
        pageName = pageNameConstants.KIDS_MOVIE_DETAIL;
      } else if (items[2] === 'kids-videos') {
        pageName = pageNameConstants.KIDS_VIDEO_DETAIL;
      }
    } else if (items[1] === 'tv-channels' && items.length === 4) {
      pageName = pageNameConstants.TV_CHANNEL_DETAIL;
    } else if (items[1] === 'tv-channels') {
      pageName = pageNameConstants.TV_CHANNEL;
    } else if (items[1] === 'live-tv') {
      if (items[1] === 'live-tv' && items[2] === 'premium-channels') {
        pageName = pageNameConstants.LIVETV_PREMIUMCHANNELS;
      } else if (items[1] === 'live-tv' && items[2] === 'free-channels') {
        pageName = pageNameConstants.LIVETV_FREECHANNELS;
      } else if (items[1] === 'live-tv' && items[2] === 'lang') {
        pageName = pageNameConstants.LIVETV_LANGUAGE;
      } else if (items[1] === 'live-tv' && items[2] === 'genre') {
        pageName = pageNameConstants.LIVETV_GENRE;
      } else if (items[1] === 'live-tv' && items[2] === 'lang-genre') {
        pageName = pageNameConstants.LIVETV_LANGUAGE_GENRE;
      } else {
        pageName = pageNameConstants.LIVETV;
      }
    } else if (items[1] === `${process.env.NEXT_PUBLIC_TVGUIDE}`) {
      pageName = pageNameConstants.TV_GUIDE;
    } else if (items[2] === 'combo-offer') {
      pageName = pageNameConstants.COMBO_PACK;
    } else if (items[1] === 'learning') {
      pageName = pageNameConstants.LEARNING;
    } else if (items[1] === 'eduauraa') {
      pageName = pageNameConstants.EDUAURAA;
    } else if (items[1] === 'offers') {
      pageName = pageNameConstants.COMBO_PACK;
    } else if (items[2] === 'cricket') {
      if (items[items.length - 1] === 'schedule') {
        pageName = pageNameConstants.ILT20_SCHEDULE;
      } else if (items.length >= 7) {
        if (
          (items[4] && items[4] === 'live-streaming') ||
          (items[4] && items[4] === 'match-clips')
        ) {
          pageName = pageNameConstants.ILT20_CONSUMPTION_PAGE;
        } else if (items[6] && items[6] === 'teams') {
          pageName = `${H1_TAG_TITLE.ILT20} ${
            items && items[7].split('-').join(' ')
          }`;
        }
      } else {
        pageName = pageNameConstants.ILT20;
      }
    } else {
      pageName = 'N/A';
    }
  }
  return pageName;
};
